import { updateTenantOrganisation } from '@infuse/api/iam/tenant';
import { useGenericUpdateOrganisation } from '@infuse/iam/organisation/mutations';

export const useUpdateTenantOrganisation = () =>
  useGenericUpdateOrganisation({
    apiFn: updateTenantOrganisation
  });
